import { createFileRoute } from '@tanstack/react-router'
import { CustomerDailyReportsPage } from '@/features/customer/pages/daily-reports'

export const Route = createFileRoute('/_authenticated/customer/daily-reports')({
  component: CustomerDailyReportsPage,
})

